/**
 * Fiskal Cloud Archive Export API
 * # Overview  Archive export API is used for * exporting imported assets in DSFinV-k cash register formats * exporting imported assets in RAW format - that means as they were imported  # Generic workflow  ## Export workflow We can export data via:  ``` curl \\ --request POST \\ --header \'Content-Type: application/json\' \\ --data-raw \'{\"exportType\": \"DSFINVK\", \"importIds\": [\"1\", \"2\"]}\' \\ https://fiskal.cloud/archiving-export-api/business-premises/{businessPremisesId}/exports ```  We receive `exportId`:  ``` {   \"id\": \"4dc75f64-5717-3214-b3fc-2c963f66aca7\" } ```  Then, we can keep polling the state until it\'s ready:  ``` curl \\ --request GET \\ https://fiskal.cloud/archiving-export-api/exports/4dc75f64-5717-3214-b3fc-2c963f66aca7 ```  ``` {   \"id\": \"3fa85f64-5717-4562-b3fc-2c963f66afa6\",   \"status\": \"PENDING\",   \"requested\": \"2020-04-20T11:47:05.471Z\" } ```  Once it\'s ready, we will get the URL where we can download the export: ``` {   \"id\": \"3fa85f64-5717-4562-b3fc-2c963f66afa6\",   \"status\": \"READY\",   \"requested\": \"2020-04-20T11:47:05.471Z\",   \"result\": {     \"url\": \"https://some-storage.lets-say.azure.com/storage/download-my-file\"   } } ``` 
 *
 * The version of the OpenAPI document: 0.18.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { CreateExportBodyDTO } from '../model/models';
import { ExportDTO } from '../model/models';
import { ExportStatusEnumDTO } from '../model/models';
import { ExportsResponseDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateExportRequestParams {
    businessPremisesId: string;
    createExportBodyDTO: CreateExportBodyDTO;
}

export class ClsCreateExportRequestParams {
    businessPremisesId: string = undefined;
    createExportBodyDTO: CreateExportBodyDTO = undefined;
}

export interface ExtendExportRequestParams {
    exportId: string;
}

export class ClsExtendExportRequestParams {
    exportId: string = undefined;
}

export interface ListExportsRequestParams {
    businessPremisesId: string;
    createdDateFrom?: string;
    createdDateTo?: string;
    status?: Array<ExportStatusEnumDTO>;
    pageNumber?: number;
    pageSize?: number;
    sort?: string;
}

export class ClsListExportsRequestParams {
    businessPremisesId: string = undefined;
    createdDateFrom?: string = undefined;
    createdDateTo?: string = undefined;
    status?: Array<ExportStatusEnumDTO> = undefined;
    pageNumber?: number = undefined;
    pageSize?: number = undefined;
    sort?: string = undefined;
}

export interface ReadExportRequestParams {
    exportId: string;
}

export class ClsReadExportRequestParams {
    exportId: string = undefined;
}


export interface ExportsApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Create export
     * Creates export with given request data. Export will probably take a long time because of data retrieval from archive storages. It\&#39;s therefor possible to register webhook url at which will be user notified when export status changes. 
* @param requestParameters
     */
    createExport(requestParameters: CreateExportRequestParams, extraHttpRequestParams?: any): Observable<ExportDTO>;

    /**
     * Extend the validity of export
     * Extend the validity of export which is related to export deletion
* @param requestParameters
     */
    extendExport(requestParameters: ExtendExportRequestParams, extraHttpRequestParams?: any): Observable<ExportDTO>;

    /**
     * List exports
     * Performs query against exports available for user
* @param requestParameters
     */
    listExports(requestParameters: ListExportsRequestParams, extraHttpRequestParams?: any): Observable<ExportsResponseDTO>;

    /**
     * Read export
     * Read detailed information about export
* @param requestParameters
     */
    readExport(requestParameters: ReadExportRequestParams, extraHttpRequestParams?: any): Observable<ExportDTO>;

}
